"use client";

import { useState } from "react";
import { X, ZoomIn, ChevronLeft, ChevronRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogClose } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [];
export default function Gallery() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const openLightbox = (index: number) => {
    setActiveIndex(index);
    setLightboxOpen(true);
  };
  const goPrev = () => {
    setActiveIndex(prev => (prev - 1 + galleryImages.length) % galleryImages.length);
  };
  const goNext = () => {
    setActiveIndex(prev => (prev + 1) % galleryImages.length);
  };
  return <section data-section-id="232026" id="divider" className="text-foreground py-28 px-4 sm:px-6 lg:px-8 bg-secondary">
      <div className="max-w-7xl mx-auto">
        {}
        

        {}
        <div ref={sectionRef} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {galleryImages.map((image, i) => <div data-index={i} key={image.id} className={`group relative cursor-pointer transition-all duration-500 ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
          transitionDelay: sectionVisible ? `${i * 60}ms` : "0ms"
        }} onClick={() => openLightbox(i)}>
              <div className="overflow-hidden rounded-none border-border border transition-all duration-300 group-hover:shadow-none">
                <AspectRatio ratio={4 / 3}>
                  <img src={image.src} alt={image.alt} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  {}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center gap-2 bg-primary/20 backdrop-blur-[2px]">
                    <div className="rounded-none p-3 shadow-none bg-primary">
                      <ZoomIn className="size-5 text-primary-foreground" />
                    </div>
                    <span className="font-default text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-none bg-background text-foreground">
                      {image.label}
                    </span>
                  </div>
                </AspectRatio>
              </div>
            </div>)}
        </div>
      </div>

      {}
      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent className="max-w-5xl w-full p-0 overflow-hidden border-none bg-transparent shadow-none" showCloseButton={false}>
          <div className="relative flex items-center justify-center rounded-none overflow-hidden bg-foreground">
            {}
            <DialogClose asChild>
              <Button variant="ghost" size="icon" className="absolute top-3 right-3 z-20 rounded-none opacity-80 hover:opacity-100 bg-background text-foreground">
                <X className="size-5" />
              </Button>
            </DialogClose>

            {}
            <Button variant="ghost" size="icon" className="absolute left-3 z-20 rounded-none opacity-80 hover:opacity-100 bg-background text-foreground" onClick={goPrev}>
              <ChevronLeft className="size-5" />
            </Button>

            {}
            <div className="w-full">
              <AspectRatio ratio={16 / 9}>
                <img src={galleryImages[activeIndex]?.src} alt={galleryImages[activeIndex]?.alt} className="w-full h-full object-cover" />
              </AspectRatio>
            </div>

            {}
            <Button variant="ghost" size="icon" className="absolute right-3 z-20 rounded-none opacity-80 hover:opacity-100 bg-background text-foreground" onClick={goNext}>
              <ChevronRight className="size-5" />
            </Button>

            {}
            <div className="absolute bottom-0 left-0 right-0 flex items-center justify-between px-6 py-3 bg-foreground/80">
              <span className="font-default text-sm font-bold text-white">
                {galleryImages[activeIndex]?.label}
              </span>
              <span className="font-default text-xs text-white/70">
                {activeIndex + 1} / {galleryImages.length}
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </section>;
}